import { render, staticRenderFns } from "./MateriaPrimeraDetail.vue?vue&type=template&id=26881b00&scoped=true"
import script from "./MateriaPrimeraDetail.vue?vue&type=script&lang=js"
export * from "./MateriaPrimeraDetail.vue?vue&type=script&lang=js"
import style0 from "./MateriaPrimeraDetail.vue?vue&type=style&index=0&id=26881b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26881b00",
  null
  
)

export default component.exports